<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div v-if="targetingCriteria != null && targetingCriteria.filter((x) => !x.isUpdatePushedExternally).length > 0">
    <div
      v-if="wrappedInPane"
      class="form-section group">
      <span class="icon"><icon-colored-pollen /></span>
      {{ capitalize($t('messages.pollenTargeting')) }}
      <div class="actions">
        <slot name="actions" />
      </div>
    </div>
    <feature-message
      v-if="isSidekickOrganization"
      :message="capitalize($t('messages.sidekickTestFeatureDefault'))" />
    <transition name="squish fade">
      <div
        v-show="isVisible"
        :class="{ 'form-section-content': wrappedInPane }">
        <div class="col-sm-12 scale-vertical">
          <div class="mb-3">
            {{ $t('messages.thisLineItemWillBeActiveDuringTheFollowingSelectedPollenConditions') }}
          </div>
          <div class="pollen-conditions">
            <selectable-tiles
              :items="allPollens"
              :is-read-only="isReadOnly"
              :should-display-labels="true"
              :should-display-icons="true"
              :should-display-checkmark-on-selected-items="true"
              label-property-name="name"
              icon-property-name="icon"
              :selected-items="internalSelectedPollenConditions"
              :is-multiselect="true"
              :allow-empty="false"
              @selection-changed="onPollenSelectionChanged" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/babel">
  import { capitalize } from 'vue';
  import { mapGetters } from 'vuex';

  import Colors from '@/Colors';
  import SelectableTiles from '@/common/components/controls/SelectableTiles';
  import allPollens from '@/common/components/controls/targeting/pollen//PollenTargetingEnumerations';
  import FeatureMessage from '@/common/components/generic-messages/FeatureMessage.vue';
  import { IconColoredPollen } from '@/common/icons/colored';
  import i18n from '@/vueI18n';

  export default {
    name: 'PollenTargeting',
    components: {
      IconColoredPollen,
      SelectableTiles,
      FeatureMessage,
    },
    props: {
      selectedPollenConditions: {
        type: Array,
        default: () => [],
      },
      isReadOnly: {
        type: Boolean,
        default: false,
      },
      targetingCriteria: {
        type: Array,
        default: () => [],
      },
      wrappedInPane: {
        type: Boolean,
        default: true,
      },
      isVisible: {
        type: Boolean,
        default: true,
      },
    },
    emits: ['selectedPollenConditionsChanged'],
    data() {
      return {
        allPollens: allPollens(),
        colors: Colors,
        i18n,
        internalSelectedPollenConditions: null,
      };
    },
    computed: {
      ...mapGetters('orgApp', ['isSidekickOrganization']),
    },
    watch: {
      selectedPollenConditions(val) {
        if (val != null) {
          this.enablePollenTargeting = true;
          this.internalSelectedPollenConditions = this.allPollens.filter((x) =>
            val.find((y) => y.localeCompare(x.id) === 0),
          );
        } else {
          this.enablePollenTargeting = false;
          this.internalSelectedPollenConditions = null;
        }
      },
      enablePollenTargeting(val) {
        if (val) {
          if (this.selectedPollenConditions == null) {
            if (this.isReadOnly) {
              return;
            }
            this.$emit('selectedPollenConditionsChanged', [...this.allPollens.map((x) => x.id)]);
          }
        } else {
          this.internalSelectedPollenConditions = null;

          if (this.isReadOnly) {
            return;
          }
          this.$emit('selectedPollenConditionsChanged', null);
        }
      },
    },
    mounted() {
      this.enablePollenTargeting = this.selectedPollenConditions != null && this.selectedPollenConditions.length > 0;

      if (this.enablePollenTargeting) {
        this.internalSelectedPollenConditions = this.allPollens.filter((x) =>
          this.selectedPollenConditions.find((y) => y.localeCompare(x.id) === 0),
        );
      }
    },
    methods: {
      capitalize(s) {
        return capitalize(s);
      },
      onPollenSelectionChanged(x) {
        if (this.isReadOnly) {
          return;
        }
        this.$emit(
          'selectedPollenConditionsChanged',
          x.map((y) => y.id),
        );
      },
      validate() {
        if (this.isReadOnly) {
          return true;
        }
        const extras = {};
        if (this.enablePollenTargeting && this.internalSelectedPollenConditions.length === 0) {
          extras.targetingCriteriaPollenConditions = {
            message: i18n.global.t('messages.pleaseSelectAtLeastOnePollenCondition'),
            preEvaluated: true,
          };
        }
        return extras;
      },
    },
  };
</script>
